import React from 'react';
import styled from 'styled-components';
import { colours, spacing, fontFamily } from '../../../theme';

const StyledButton = styled.button`
  background: ${colours.yellow};
  padding: ${spacing.tiny};
  font-family: ${fontFamily.baseFont};
  font-weight: bold;
  font-size: 1em;
  min-width: 11em;
  text-transform: uppercase;
  border: none;
  margin: ${spacing.tiny}
  color: ${colours.black}
  cursor: pointer;
`;

const Button = ({ label, ...props }) => {
  return <StyledButton {...props}>{label}</StyledButton>;
};

export default Button;
